import Vue from 'vue'
import InputText from './InputGeneric.vue'

Vue.component('InputText', InputText)
